<template>
  <b-modal
    ref="ricercaUtenti"
    size="xl"
    hide-header
    hide-footer
  >
    <div>
      <b-table
        :items="rows"
        striped
        selectable
        select-mode='single'
        @row-selected="onRowSelected"
        responsive="md"
        :fields="fields"
        bordered
        small
        style="width:100%;font-size:.9rem;"
        class="mt-3 mb-1 align-middle text-center"
        align
        :per-page="perPage"
        :currentPage="currentPage"
      >
      </b-table>
      <div class="row justify-content-between mx-0 mt-0 mb-2 align-middle">
        <div class="text-right">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          @click="close()"
        >Close</button>
        <button
          :disabled="toClose"
          type="button"
          class="btn btn-primary"
          @click="utenteTrovato(scelto)"
        >Utente scelto</button>
      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
  name: 'RicercaUtente',
  props: {
    utentiTrovati: { type: Array, required: true },
    modello: { type: Object, required: true }
  },

  data () {
    return {
      scelto: '',
      fields: [
        { key: 'codiceUtente', sortable: true },
        { key: 'nome', sortable: true },
        { key: 'cognome', sortable: true },
        { key: 'codiceFiscale', sortable: true }],
      rows: [],
      selected: [],
      perPage: 20,
      currentPage: 1
    }
  },

  computed: {
    toClose () {
      if (this.scelto) return false
      else return true
    },
    totalRows () { return this.rows.length }
  },

  methods: {
    open () {
      this.$refs.ricercaUtenti.show()
      this.utentiTrovati.forEach(utente => {
        let row = {
          codiceUtente: utente.codiceUtente,
          nome: utente.nome,
          cognome: utente.cognome,
          codiceFiscale: utente.codiceFiscale
        }
        this.rows.push(row)
      })
    },
    close () {
      this.emptyRows()
      this.currentPage = 1
      this.$refs.ricercaUtenti.hide()
    },
    utenteTrovato (s) {
      this.currentPage = 1
      this.modello.utente = s
      this.emptyRows()
      this.$refs.ricercaUtenti.hide()
    },
    onRowSelected (items) {
      this.selected = items
      if (this.selected[0] && this.selected[0].codiceUtente) this.scelto = this.selected[0].codiceUtente
    },
    emptyRows () {
      this.rows = []
    }
  }
}
</script>
